<template>
    <v-card style="background-color: rgba(255,255,255,0); -webkit-box-shadow: 0px 0px 0px 0px rgba(0,0,0,0); box-shadow: 0px 0px 0px 0px rgba(0,0,0,0);">
        <v-card-actions
            class="justify-center transparent battle-actions-row"
            :class="{'compact-labels': visibleActionButtonCount >= 3}"
        >

            <!-- canCatch() = boss poražený - dokud platí, Leave/Evaluate se schovají,
                 hráč musí pokračovat přes Explore more/Catch! až do konce (ať nepřijde o odměnu) -->
            <v-btn
                v-if="!isDungeonChallenge && !canCatch()"
                :loading="isLoading"
                color="warning black--text btn-shadow"
                @click="escapeDung"
                style="opacity: 1;"
            >
                {{ $t('journey.dungeonButtons.leaveLabel') }}
            </v-btn>
            <v-btn
                v-if="isDungeonChallenge && !canCatch()"
                :loading="isLoading"
                color="warning black--text btn-shadow"
                @click="evaluateDungChallenge"
                style="opacity: 1;"
            >
                {{ $t('journey.dungeonButtons.evaluateLabel') }}
            </v-btn>

            <v-btn
                :loading="isLoading"
                v-if="canRecallPokemon()"
                color="blue-grey lighten-2 black--text btn-shadow"
                @click="recallPokemon"
            >
                {{ $t('journey.dungeonButtons.recallLabel') }}
            </v-btn>

            <!-- druhá cesta k PokemonPickerDialog.vue vedle klikací "choose" dlaždice v gridu, viz FightButtons.vue -->
            <v-btn
                :loading="isLoading"
                v-if="canChoosePokemon()"
                color="amber black--text btn-shadow"
                @click="choosePokemon"
            >
                {{ $t('journey.dungeonButtons.chooseLabel') }}
            </v-btn>

            <v-btn
                v-if="canContinueRoad()"
                :loading="isLoading"
                color="primary black--text btn-shadow"
                @click="goToDungeon"
                style="opacity: 1;"
            >
                {{ $t('journey.dungeonButtons.exploreLabel') }}<span class="explore-more-suffix">&nbsp;{{ $t('journey.dungeonButtons.exploreMoreSuffixWord') }}</span>
            </v-btn>
            <CatchDialog
                ref="catchDialog"
                :fight="fight"
                catch-endpoint="api/catch-boss-pokemon"
                :ball-count="fight.trainer.masterballs"
                ball-icon="mdi-baseball"
                :can-catch="canCatch()"
                :with-sound="false"
            >
                <!-- "!canCatch()" guard se tady NEpoužívá - slot se renderuje uvnitř
                     už otevřeného catch dialogu, ne v hlavní akční liště. Leave/Evaluate
                     jsou tu schované vždy, když je zároveň k dispozici Explore more -
                     jen pro double-KO (canContinueRoad()==false, kdy Explore nejde)
                     zůstávají jako jediná funkční cesta ven z perzistentního dialogu. -->
                <template #actions>
                    <v-btn
                        v-if="!isDungeonChallenge && !canContinueRoad()"
                        :loading="isLoading"
                        color="warning black--text btn-shadow"
                        @click="escapeDung"
                        style="opacity: 1;"
                    >
                        {{ $t('journey.dungeonButtons.leaveLabel') }}
                    </v-btn>
                    <v-btn
                        v-if="isDungeonChallenge"
                        :loading="isLoading"
                        color="warning black--text btn-shadow"
                        @click="evaluateDungChallenge"
                        style="opacity: 1;"
                    >
                        {{ $t('journey.dungeonButtons.evaluateLabel') }}
                    </v-btn>
                    <v-btn
                        v-if="canContinueRoad()"
                        :loading="isLoading"
                        color="primary black--text btn-shadow"
                        @click="callGotToDungeon"
                        style="opacity: 1;"
                    >
                        {{ $t('journey.dungeonButtons.exploreLabel') }}<span class="explore-more-suffix">&nbsp;{{ $t('journey.dungeonButtons.exploreMoreSuffixWord') }}</span>
                    </v-btn>
                </template>
            </CatchDialog>
        </v-card-actions >
        <ConfirmDialog ref="confirmDialog"/>
    </v-card>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import CatchDialog from '@/components/journey/positions/battle/CatchDialog';
    import ConfirmDialog from '@/components/utils/ConfirmDialog';

    export default {
        components: {CatchDialog, ConfirmDialog},
        props: {
            fight: {Object, default: null},
            trainerFight: {Object, default: null},
            obstacleFight: {Object, default: null},
            isTrainerFight:  {Boolean, default: false},
            isDungeonChallenge:  {Boolean, default: false},
            cityId:  {Number, default: false},
            wild: {String, default: null},
            goToDungeon: {Function, default: () => {}},
            resetSkill: {Function, default: () => {}},
            masterballs: {Number, default: 0},
        },
        data() {
            return {
                recallSound: {Object, default: null},
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
                user: 'user/item',
                steps: 'journey/steps',
                buttonVolume: 'journey/buttonVolume',
            }),
            // zkrácení popisků má smysl jen od 3 tlačítek současně A na úzké šířce
            // (obě podmínky najednou) - viz .compact-labels třída + media query ve <style>
            visibleActionButtonCount() {
                let count = 0;
                if (!this.canCatch()) {
                    count++; // přesně jedno z Leave/Evaluate
                }
                if (this.canRecallPokemon() || this.canChoosePokemon()) {
                    count++; // vzájemně se vylučují
                }
                if (this.canContinueRoad()) {
                    count++;
                }
                if (this.canCatch()) {
                    count++;
                }
                return count;
            },
        },
        created() {
            let backgroundSound = require('@/assets/sounds/recall.mp3');
            this.recallSound = new Audio(backgroundSound);
        },
        methods: {
            ...mapActions({
                positionPost: 'journey/positionPost',
                pokemonFight: 'journey/pokemonFight',
                loadPosition: 'journey/loadPosition',
                meetPokemon: 'journey/meetPokemon',
                trainerInfoMessages: 'trainer/loadInfoMessages',
            }),
            resetCatchDialog() {
                if (this.$refs.catchDialog) {
                    this.$refs.catchDialog.reset();
                }
            },
            callGotToDungeon() {
                this.resetCatchDialog();
                this.goToDungeon();
            },
            // obě akce jsou těžko vratné - stejný vzor jako Surrender v FightButtons.vue
            async escapeDung(){
                let rlyLeave = await this.$refs.confirmDialog.open(this.$t('journey.dungeonButtons.confirmLeave'));
                if (!rlyLeave) {
                    return;
                }
                this.resetCatchDialog();
                const url = new URL("api/escape-dungeon", API_ENTRYPOINT);
                const obj = {url: url, obj:{positionId: this.user.position.id},method:'POST'}
                this.positionPost(obj);
            },
            async evaluateDungChallenge(){
                let rlyEvaluate = await this.$refs.confirmDialog.open(this.$t('journey.dungeonButtons.confirmEvaluate'));
                if (!rlyEvaluate) {
                    return;
                }
                this.resetCatchDialog();
                const url = new URL("api/evaluate-dung-challenge", API_ENTRYPOINT);
                const obj = {url: url, obj:{positionId: this.user.position.id},method:'POST'}
                this.positionPost(obj);
            },
            recallPokemon(){
                // otevře jen sdílený picker - samotný výběr (api/add-to-fight) atomicky
                // nahradí trainerPokemon za nově zvoleného, viz stejný komentář ve FightButtons.vue
                this.recallSound.volume = this.buttonVolume / 100;
                this.recallSound.time = 0;
                this.recallSound.play();
                this.$emit('recall-pokemon');
            },
            choosePokemon(){
                this.$emit('choose-pokemon');
            },
            canChoosePokemon(){
                return this.wild.dungeon.actualPosition === "pokemon" && !!(this.fight && !this.fight.trainerPokemon);
            },
            canContinueRoad(){
                this.resetSkill();
                if (this.wild.dungeon.actualPosition === "pokemon"){
                    if (this.fight && this.fight.trainerPokemon && this.fight.trainerPokemon.hp >= 1 && this.fight.opponentPokemon.hp < 1){
                        return true;
                    }
                    return false;
                } else {
                    return this.obstacleFight !== null && this.obstacleFight.currentHp < 1;
                }
            },
            // Recall (výměna AKTIVNÍHO pokémona) a Choose (výběr PRVNÍHO) se vzájemně
            // vylučují - bez kontroly trainerPokemon by se obě zobrazovaly zároveň.
            // Recall navíc jen dokud soupeř žije - u poraženého soupeře (0 HP) je
            // souboj fakticky rozhodnutý (Catch!/Explore more/Leave jsou další kroky).
            canRecallPokemon(){
                return this.wild.dungeon.actualPosition === "pokemon"
                    && !!(this.fight && this.fight.trainerPokemon)
                    && !!(this.fight.opponentPokemon && this.fight.opponentPokemon.hp >= 1);
            },
            canCatch(){
                if (this.fight && this.fight.trainerPokemon && this.fight.bossFight && this.wild.dungeon.actualPosition === "pokemon") {
                    if((this.fight.opponentPokemon.hp <= 0 && this.fight.trainerPokemon.hp > 0 )
                        || (this.fight.trainerPokemon.hp < 1 && this.fight.opponentPokemon.hp < 1 )
                    ){
                        return true;
                    }
                }
                return false;
            },
        },
    }
</script>

<style scoped>
/* tlačítka natvrdo drží na jednom řádku (žádné zalomení do dvou) - zkrácené
   popisky (Leave/Explore/Evaluate) + zmenšený padding, ať se i s víc tlačítky
   (Leave/Recall/Explore/Catch!) vejdou i na mobilní šířku (390px) */
.battle-actions-row {
    flex-wrap: nowrap;
}
.battle-actions-row >>> .v-btn {
    padding: 0 8px;
    min-width: 0;
}
/* 2 tlačítka se vejdou vždy i s plným "Explore more" (default display:inline) -
   zkrácení na "Explore" nastane jen když jsou SOUČASNĚ splněné obě podmínky:
   3+ tlačítek najednou (.compact-labels, viz visibleActionButtonCount()) A
   úzká šířka (media query níže). */
.explore-more-suffix {
    display: inline;
}
@media (max-width: 399px) {
    .compact-labels .explore-more-suffix {
        display: none;
    }
}
</style>

